module.exports = __webpack_public_path__ + "img/right.5c6199a8.png";